<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
        </div>
        <NevsCard class="form">
            <h2>{{ $LANG.Get('labels.membershipReminderSettings') }}</h2>
            <NevsCheckbox v-model="client.send_membership_reminder"
                          :label="$LANG.Get('fields.sendMembershipReminder')"></NevsCheckbox>
            <NevsTextField v-if="client.send_membership_reminder" v-model="client.membership_reminder_days"
                           :error="clientValidation.membership_reminder_days"
                           :label="$LANG.Get('fields.membershipReminderDays') + ':'"></NevsTextField>
            <p v-if="client.send_membership_reminder" class="disclaimer">{{ $LANG.Get('labels.membershipReminderDisclaimer') }}</p>
            <template v-if="client.send_membership_reminder && smtpConfigured">
                <NevsTextField v-model="client.membership_expiry_email_subject"
                               :label="$LANG.Get('fields.membershipExpiryEmailSubject') + ':'"></NevsTextField>
                <NevsTextArea v-model="client.membership_expiry_email_body"
                              :label="$LANG.Get('fields.membershipExpiryEmailBody') + ':'"></NevsTextArea>
            </template>
            <p v-if="client.send_membership_reminder && !smtpConfigured" class="disclaimer">{{ $LANG.Get('labels.membershipExpirySmtpNote') }}</p>
        </NevsCard>
    </div>
</template>

<script>
import Client from "@/models/Client.js";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";

export default {
    name: "MembershipSettings",
    components: {NevsTextArea, NevsTextField, NevsCheckbox, NevsCard, NevsButton},
    data() {
        return {
            loaded: false,
            client: new Client(),
            clientValidation: new Client({}, true)
        }
    },
    computed: {
        smtpConfigured() {
            const c = this.$store.state.user.client;
            return c.use_smtp && c.smtp_host !== '' && parseInt(c.smtp_port) > 0 && c.smtp_from_address !== '';
        }
    },
    methods: {
        saveClick() {
            let valid = true;

            if (this.client.send_membership_reminder) {
                let days = parseInt(this.client.membership_reminder_days);
                if (isNaN(days) || days <= 0) {
                    valid = false;
                    this.clientValidation.membership_reminder_days = this.$LANG.Get('labels.reminderDaysInvalid');
                } else {
                    this.clientValidation.membership_reminder_days = '';
                    this.client.membership_reminder_days = days;
                }
            }

            if (valid) {
                let vm = this;
                this.$API.APICall('put', 'client', this.client, (data, success) => {
                    if (success) {
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', []);

        if (!this.$store.state.user.permissions.includes('ADMINISTRATOR')) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
        }
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'membershipSettings');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.settings'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.membershipSettings'),
                link: null
            }
        ]);

        let vm = this;
        this.$API.APICall('get', 'client', {}, (data, success) => {
            if (success) {
                if (data.client !== null) {
                    vm.client.Fill(data.client);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            } else {
                vm.$HELPERS.HandleServerError(vm, data);
            }
            vm.$nextTick(() => {
                vm.loaded = true;
            });
        });
    }
}
</script>

<style scoped>
.form {
    max-width: 600px;
    margin-bottom: 10px;
    padding: 15px;
}

.disclaimer {
    font-size: 0.9em;
    opacity: 0.7;
    margin-top: 5px;
}
</style>
